// Base API URL for fetching product data
const API_URL = "https://hasanmart.onrender.com/api/products";

// Function to fetch all products from the API
export const fetchProducts = async () => {
  try {
    const response = await fetch(API_URL);
    return await response.json(); // Parse and return the JSON response
  } catch (error) {
    console.error("Error fetching products:", error);
    return []; // Return an empty array in case of an error
  }
};

// Function to fetch a single product by its ID
export const getProductById = async (id) => {
  const response = await fetch(`${API_URL}/${id}`);
  return response.json(); // Parse and return the JSON response
};

// Function to fetch products by category
export const getProductsByCategory = async (category) => {
  try {
    const response = await fetch(
      `https://hasanmart.onrender.com/api/products/category/${category}`
    );
    return response.ok ? response.json() : []; // Return JSON if response is OK, otherwise return an empty array
  } catch (error) {
    console.error("Error fetching products by category:", error);
    return []; // Return an empty array in case of an error
  }
};
